import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView              from "./TemplateListView";
import DatapointTypeAdminDetailsView from "./DatapointTypeAdminDetailsView";
import DatapointTypeAdminNewView     from "./DatapointTypeAdminNewView";


const DatapointTypeAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      name: t("I18N_Code"),
      sortable: true,
      sortField: 'code',
      grow: 2.5,
      cell: null
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Category"),
      selector: row => t("I18N_" + row.category),
      sortable: true,
      sortField: 'category',
    },
    {
      name: t("I18N_Type"),
      selector: row => t("I18N_" + row.type),
      sortable: true,
      sortField: 'type',
    },
    {
      name: t("I18N_Subsystem"),
      selector: row => row.subsystem,
      sortable: true,
      sortField: 'subsystem',
    },
    {
      name: t("I18N_Data_type"),
      selector: row => t("I18N_" + row.dataType),
    },
    {
      name: t("I18N_Unit"),
      //selector: row => row.unitDesc + (row.unitSymbol ? ' (' + row.unitSymbol.trim() + ')' : ''),
      selector: row => row.unitSymbol ? row.unitSymbol.trim() : row.unitDesc,
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----

  const searchFieldOptions = [
    { key: "CODE",  value: "CODE" },
    { key: "DESCRIPTION", value: "DESCRIPTION" }
  ];


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_DATA_MGMT_API}
                                                  apiObjName={'datapoint-types'}
                                                  listPageTitle={t("I18N_DataPtType_Management")}
                                                  newObjTooltip={t("I18N_TIP_New_datapoint_type")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Datapoint_type_delete_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_dptype")}
                                                  tableColumns={tableColumns}
                                                  primaryIdColType={'CODE'}
                                                  searchFieldOptions={searchFieldOptions}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <DatapointTypeAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <DatapointTypeAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default DatapointTypeAdmin;
